import Vue from 'vue'
import VueRouter from 'vue-router'
import SetUp from '../views/SetUp.vue'
import NumerosRecepcion from '../views/Recepcion/Numeros.vue'
import LlamadasPlaceHolder from '../views/Llamadas/LlamadasPlaceHolder.vue'

import TotemHome from '../views/AutoRecepcion/Home.vue'
import PrintNumber from '../views/AutoRecepcion/PrintNumber.vue'
import PrintAttention from '../views/AutoRecepcion/PrintAttention.vue'
import MessageScreen from '../views/AutoRecepcion/MessageScreen.vue'
import PatientAppointmentNotFound from '../views/AutoRecepcion/PatientAppointmentNotFound.vue'
import PatientSearch from '../views/AutoRecepcion/PatientSearch.vue'
import PatientSelector from '../views/AutoRecepcion/PatientSelector.vue'
import ServiceSelector from '../views/AutoRecepcion/ServiceSelector.vue'
import AppointmentSelector from '../views/AutoRecepcion/AppointmentSelector.vue'
import IdleScreen from '../views/AutoRecepcion/IdleScreen.vue'
import ErrorScreen from '../views/AutoRecepcion/ErrorScreen.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/',
    name: 'SetUp',
    component: SetUp
  },
  {
    path: '/recepcion',
    name: 'NumerosRecepcion',
    component: NumerosRecepcion
  },
  {
    path: '/llamadas',
    name: 'Llamadas',
    props: true,
    component: LlamadasPlaceHolder
  },
  { path: '/totemHome/:salaId?/:totemId?', component: TotemHome, name: 'TotemHome' },
  { path: '/patients/search', component: PatientSearch, name: 'patientSearch' },
  { path: '/patients/selector', component: PatientSelector, name: 'patientSelector', props: true },
  { path: '/services/selector', component: ServiceSelector, name: 'serviceSelector', props: true },
  { path: '/appointments/idle', component: IdleScreen, name: 'IdleScreen', props: true },
  { path: '/error', component: ErrorScreen, name: 'ErrorScreen' },
  { path: '/patients/appointments', component: AppointmentSelector, name: 'appointmentSelector' },
  { path: '/appointments/print', component: PrintNumber, name: 'printNumber', props: true },
  { path: '/appointments/printAttention', component: PrintAttention, name: 'printAttention', props: true },
  { path: '/appointments/message', component: MessageScreen, name: 'messageScreen', props: true },
  { path: '/appointments/patientAppointmentNotFound', component: PatientAppointmentNotFound, name: 'patientAppointmentNotFound', props: true }
]

const router = new VueRouter({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
